<template>
  <div>
    <PageLoader v-bind:storage="appLoading" />
    <ServerError v-if="ServerError" />
    <v-snackbar v-model="showSnackBar" color="#3ea56e" right :timeout="timeout">
      <v-layout wrap justify-center>
        <v-flex text-left class="align-self-center">{{ msg }}</v-flex>
        <v-flex text-right>
          <v-btn small :ripple="false" text @click="showSnackBar = false">
            <v-icon style="color: white">mdi-close</v-icon>
          </v-btn>
        </v-flex>
      </v-layout>
    </v-snackbar>
    <v-dialog v-model="deleteDialogue" width="400">
      <v-card>
        <v-layout pa-4 wrap justify-center>
          <v-flex xs12>
            <span style="color: #000000; font-family: opensanssemibold; font-size: 18px;">
              Do you want to delete this Notification ?
            </span>
          </v-flex>
          <v-flex xs6 px-2>
            <v-btn tile block depressed dark color="#ff1313" @click="deleteNotification()">
              <span style="font-family: poppinsregular; font-size: 14px">Yes</span>
            </v-btn>
          </v-flex>
          <v-flex xs6 px-2>
            <v-btn tile block depressed dark color="#1BD93B" @click="deleteDialogue = false">
              <span style="font-family: poppinsregular; font-size: 14px">No</span>
            </v-btn>
          </v-flex>
        </v-layout>
      </v-card>
    </v-dialog>
    <v-layout wrap justify-start pt-4 px-2 px-lg-0 pl-lg-4 pl-xl-4>
      <v-flex xs12>
        <v-layout pt-3 wrap justify-start>
          <v-flex xs7 sm3 md3 lg2 xl2>
            <v-layout wrap justify-center>
              <!-- <v-flex xs3 sm2 text-left align-self-center>
                <v-img
                  src="./../../../assets/icon.png"
                  contain
                  height="15px"
                ></v-img>
              </v-flex> -->
              <v-flex xs12 sm12 text-left align-self-center>
                <span
                  style="
                    font-family: poppinssemibold;
                    font-size: 18px;
                    color: #1c1c1c;
                  "
                >
                  Notification
                </span>
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>
    <v-layout
      wrap
      justify-start
      pt-4
      px-2
      pl-xl-4
      v-for="(item, i) in orders"
      :key="i"
    >
      <v-flex
        xs12
        text-left
        pb-4
        pl-2
        v-if="item.routetype == 'limitedStock' || item.routetype=='outofStock' && item.routeId1"
      >
        <router-link :to="'/Seller/Product/' + item.routeId1">
          <span
            style="font-family: opensansbold; font-size: 20px; color: #808080"
          >
            {{ item.title }}
          </span>
        </router-link>
      </v-flex>
      <v-flex xs12 text-left pb-4 pl-2 v-else>
        <span
          style="font-family: opensansbold; font-size: 20px; color: #808080"
        >
          {{ item.title }}
        </span>
      </v-flex>
      <v-flex xs12 sm6 md6 lg4 xl4 text-start pa-2>
        <span style="font-family: opensansbold; font-size: 16px;">
          {{ item.body }}
        </span>
      </v-flex>
      <v-flex>
        <span style="font-family: opensansbold; font-size: 16px;">{{
          formatDate(item.update_date)
        }}</span>
      </v-flex>
      <v-flex xs1>
        <v-icon @click="openDeleteDialog(item._id)">mdi-delete</v-icon>
      </v-flex>
      <v-flex xs12 py-2>
        <v-divider></v-divider>
      </v-flex>
    </v-layout>
    <v-layout wrap justify-center v-if="orders.length < 1">
      <v-flex xs12>
        <span
          style="font-family: poppinsregular; font-size: 25px; color: #000000"
        >
          Oops! No Data Found
        </span>
      </v-flex>
    </v-layout>
  </div>
</template>
<script>
import axios from "axios";
// import CancelledOrdersItem from "./cancelledOrdersItem";
export default {
  components: {
    // CancelledOrdersItem,
  },
  data() {
    return {
      appLoading: false,
      timeout: 5000,
      msg: "",
      ServerError: false,
      showSnackBar: false,
      orders: [],
      deleteDialogue: false,
      itemToDelete: null,
    };
  },
  beforeMount() {
    this.getData();
  },
  methods: {
    getData() {
      this.appLoading = true;
      axios({
        method: "POST",
        url: "/notifications/all/list",
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
        // data: {
        //   orderStatus: ["Cancelled","Cancelled By Seller"],
        // },
      })
        .then((response) => {
          if (response.data.status) {
            this.appLoading = false;
            this.orders = response.data.data;
          } else {
            this.appLoading = false;
            this.msg = response.data.msg;
            this.showSnackBar = true;
          }
        })
        .catch((err) => {
          this.appLoading = false;
          this.ServerError = true;
          console.log(err);
        });
    },
    openDeleteDialog(id) {
      this.itemToDelete = id;
      this.deleteDialogue = true;
    },
    deleteNotification() {
      const id = this.itemToDelete;
      if (!id) return;
      this.appLoading = true;
      axios({
        method: "POST",
        url: "/notification/remove/" + id,
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
      })
        .then((response) => {
          this.appLoading = false;
          if (response.data.status) {
            this.msg = "Notification Deleted Successfully";
            this.showSnackBar = true;
            this.deleteDialogue = false;
            this.getData();
            this.$root.$emit('notification-deleted');
          }
        })
        .catch((err) => {
          this.ServerError = true;
          console.log(err);
        });
    },
    formatDate(item) {
      var defDate = new Date(item);
      defDate = defDate.toString().slice(0, 15);
      var today = new Date();
      today = today.toString().slice(0, 15);

      var yesterday = new Date();
      yesterday.setDate(yesterday.getDate() - 1);
      yesterday = yesterday.toString().slice(0, 15);

      var dt = new Date(item);
      var day = dt.getDate();
      var year = dt.getFullYear();
      dt = dt.toString();
      var strTime = dt.slice(0, 4) + day + " " + dt.slice(4, 7) + " " + year;

      if (today == defDate) {
        return "Today";
      } else if (yesterday == defDate) {
        return "Yesterday";
      } else {
        return strTime;
      }
    },
  },
};
</script>
